<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title text-primary">
              <strong class="uppercase"
                >HISTORY SERVICE & REPAIR - {{ fleets }}</strong
              >
            </h4>
          </template>
          <template v-slot:headerAction>
            <a
              class="text-primary float-right"
              v-b-toggle.collapse-filter
              role="button"
              style="cursor: pointer"
              ><i class="fa fa-calendar"
            /></a>
          </template>
          <template v-slot:body>
            <b-collapse id="collapse-filter" class="mb-2">
              <b-row>
                <b-col md="6">
                  <date-picker
                    :lang="lang"
                    v-model="dateRange"
                    type="date"
                    range
                    placeholder="Select date range"
                  ></date-picker>
                </b-col>
                <b-col md="5" />
              </b-row>
            </b-collapse>
            <table class="table table-striped">
              <thead>
                <th>Loaction</th>
                <th>Accident Date</th>
                <th>Actual Start Date</th>
                <th>Actual Finish Date</th>
                <th>Total Days</th>
                <th>Total Item Repair</th>
                <th>Pic</th>
                <th>Action</th>
              </thead>
              <tbody>
                <template v-if="list_repair_finished.data">
                  <tr
                    v-for="(item, index) in list_repair_finished.data"
                    :key="index"
                  >
                    <td>{{ item.location }}</td>
                    <td>{{ toFormatDate(item.accident_at) }}</td>
                    <td>{{
                      item?.start_date_real
                        ? toFormatDate(item?.start_date_real)
                        : '-'
                    }}</td>
                    <td>{{
                      item?.finish_date_real
                        ? toFormatDate(item?.finish_date_real)
                        : '-'
                    }}</td>
                    <td>
                      {{
                        totalDays(item.start_date_real, item.finish_date_real)
                      }}
                      Days
                    </td>
                    <td>{{ item.total_repair }} Repair</td>
                    <td class="d-flex flex-column">
                      <p class="mb-0">{{ item.pic }}</p>
                    </td>
                    <td>
                      <b-dropdown
                        text="Action"
                        size="sm"
                        variant="outline-primary"
                      >
                        <b-dropdown-item
                          @click="() => handleAction(item, 'detail')"
                          >Detail Service & Repair</b-dropdown-item
                        >
                      </b-dropdown>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <div class="mt-3" v-if="list_repair_finished?.data?.length > 0">
              <b-pagination
                v-model="list_repair_finished.meta.page"
                :total-rows="list_repair_finished.meta.total_item"
                :per-page="list_repair_finished.meta.per_page"
                aria-controls="my-table"
                @change="getListFinishedTableServiceAndRepairById"
                align="center"
                first-number
              />
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { xray } from '../../config/pluginInit'
import { fleetsActions, crewingActions, srActions } from '@src/Utils/helper'
import moment from 'moment'
import optionsData from '@src/core/mock/data'
import { saveAs } from 'file-saver'
import router from '@/src/router/index'

export default {
  name: 'ServiceRepairHistoryNew',
  data() {
    return {
      ...optionsData,
      apiUrl: `${process.env.VUE_APP_API_BASE_URL}/sr`,
      fleets: '',
      dateRange: null,
      optionsDepartment: [],

      loading_table: false,
      loading_detail: false,

      list_repair_finished: {
        data: [],
        meta: null,
      },
      detail_repair_finished: null,
    }
  },
  async mounted() {
    xray.index()
    this.dateRange = this.defaultRange

    await this.getListFinishedTableServiceAndRepairById()
    await this.getMasterDepartment()
    await this.fetchFleets()
  },
  computed: {
    defaultRange() {
      const currentDate = new Date()
      const nextDay = new Date(currentDate)
      nextDay.setDate(currentDate.getDate() + 1)
      // Get the last date of the current month
      let lastDateOfMonth = moment().endOf('month')
      lastDateOfMonth = new Date(lastDateOfMonth)
      // Format it to show only the date
      const firstMonthOfTheYear = new Date(currentDate.getFullYear(), 0, 1)
      return [firstMonthOfTheYear, lastDateOfMonth]
    },
  },
  created() {
    this.getListFinishedTableServiceAndRepairById = _.debounce(
      this.getListFinishedTableServiceAndRepairById,
      500
    )
  },
  watch: {
    dateRange: {
      handler(n, o) {
        this.getListFinishedTableServiceAndRepairById()
      },
      immediate: true,
    },
  },
  methods: {
    ...fleetsActions,
    ...srActions,
    ...crewingActions,
    totalDays(startDate, endDate) {
      return moment(endDate).diff(moment(startDate), 'days')
    },
    handleAction(item, type) {
      let url = `/sr/service-repair-form?vehicleId=${this.$route.query.vehicleId}&formId=${item.id}`
      if (type == 'detail') {
        url += '&detail=true'
      }
      this.$router.push(url)
    },
    toFormatDate(val) {
      const formateDate = moment(val).format('DD MMM YYYY')
      return formateDate
    },
    positionName(value) {
      let position_name = this.optionsJabatan.find(
        (obj) => Number(value) === Number(obj.value)
      )

      return position_name?.text ?? 'N/A'
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)
    },
    handleOpenFilePreview: function (url, name) {
      let extension = this.getFileExtension(url)
      saveAs(url, name + extension)
    },
    getFileExtension(url) {
      const match = url.match(/\.([a-zA-Z0-9]+)(\?|$)/)
      return match ? `.${match[1]}` : null
    },
    departmentName(value) {
      let department_name = null
      return department_name?.text ?? 'N/A'
    },
    async getMasterDepartment() {
      let res = await this.fetchMasterDepartmentList()
      if (!res.status) {
        this.optionsDepartment = []
      } else {
        res.data.data.map((val) => {
          this.optionsDepartment.push({
            text: val.name,
            value: val.id,
          })
        })
      }
    },

    async fetchFleets() {
      let params = {
        page: 1,
        showAll: true,
      }
      let res = await this.getFleets(params)
      if (!res.status) {
        this.fleets = 'N/A'
      } else {
        let tempFleets = res.data.find(
          (obj) => Number(this.$route.query.vehicleId) === obj.id
        )
        this.fleets = tempFleets.name
      }
    },

    async getListFinishedTableServiceAndRepairById(page) {
      if (this.$route.query.vehicleId) {
        this.loading_table = true
        let params = {
          start_date: moment(this.dateRange?.[0]).format('YYYY-MM-DD'),
          end_date: moment(this.dateRange?.[1]).format('YYYY-MM-DD'),
          page: page || 1,
        }

        let res = await this.fetchListTableFinishedServiceAndRepairById({
          id: this.$route.query.vehicleId,
          params,
        })

        if (res.status === 'error') {
          this.list_repair_finished = null
          this.loading_table = false
        } else {
          this.list_repair_finished.data = res.data.data
          this.list_repair_finished.meta = res.data.meta
          this.loading_table = false
        }
      }
    },
  },
}
</script>
